import { SurveyQuestion } from '@/plugins/api'
import { sortBy } from 'lodash'

export default {
  namespaced: true,
  state: {
    items: [],
    item: {},
    totalCount: 0,
    loading: false
  },
  actions: {
    async fetch({ commit }, params) {
      const items = await SurveyQuestion.fetch(params)
      commit('changeState', { items: sortBy(items, i => i.index) })
    },
    async count({ commit }, params) {
      const totalCount = await SurveyQuestion.count(params)
      commit('changeState', { totalCount })
    },
    async create(_, data) {
      await SurveyQuestion.create(data)
    },
    async update(_, { id, ...data }) {
      await SurveyQuestion.update(id, data)
    },
    async remove(_, id) {
      await SurveyQuestion.remove(id)
    }
  },
  mutations: {
    setState(state, { atr, value }) {
      state[atr] = value
    }
  },
  getters: {
    items: state => state.items,
  }
}
